import { ReviewSection } from '@/components/checkout/section/ReviewSection';

export const ReportSection = () => {
  return (
    <>
      <ReviewSection readOnly />
    </>
  );
};
